import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import { AppButton } from "../../../../shared/components/AppButton";
import { ButtonProps } from "@mui/material";

export const ImportSchemeBtn = ({ ...props }: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"outlined"}
      className={styles["import-schema-btn"]}
      {...props}
    >
      {t("schemas.import_schema_btn")}
    </AppButton>
  );
};
